export default __webpack_public_path__ + "static/media/baner.16235ee7.webp";